import { TreeNode } from "@/types/tree";
import { treeNodesOfType } from "@/lib/tree/tree";
import { getClassNameForNode } from "../elements/utils";
import { configStore } from "@/store/store-accessor";

export function getAllSlidersInTree(tree: TreeNode, postId: number) {
  const postTypes = [
    "EssentialElements\\Postslist",
    "EssentialElements\\PostsLoop",
    "EssentialElements\\DynamicDataLoop"
  ];

  return treeNodesOfType(tree, [
    "EssentialElements\\Basicslider",
    "EssentialElements\\Advancedslider",
    "EssentialElements\\TermLoopBuilder",
    ...postTypes
  ])
    .filter(sliderNode => {
      const isPostElement = postTypes.includes(sliderNode.data.type);

      // Only show posts list or posts loop elements that are sliders.
      if (isPostElement) {
        const layout = sliderNode.data?.properties?.design?.list?.layout;
        return layout === "slider";
      }

      return true;
    })
    .map(sliderNode => {
      const name = configStore.element(sliderNode.data.type).name;
      return {
        id: sliderNode.id,
        name: `${name} #${sliderNode.id}`,
        uniqueClassName: getClassNameForNode(sliderNode, postId)
      };
    });
}
